import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import {
  NotificationActivityKind,
  NotificationSettingsStatus,
  NotificationSeverity,
  NotificationType,
} from '@enmon/commons/lib/enmon';
import { COMMON_TABLE_MESSAGES_TRANSLATED } from './tables';

export const NOTIFICATIONS_TRANSLATED = defineMessages<NotificationType>({
  [NotificationType.QuarterhourMax]: {
    id: 'app.common.notifications.quarterhourMax',
  },
  [NotificationType.HourMax]: {
    id: 'app.common.notifications.hourMax',
  },
  [NotificationType.DayMax]: {
    id: 'app.common.notifications.dayMax',
  },
  [NotificationType.ValueRange]: {
    id: 'app.common.notifications.valueRange',
  },
  [NotificationType.MissingInvoice]: {
    id: 'app.common.notifications.missingInvoice',
  },
  [NotificationType.NoMessage]: {
    id: 'app.common.notifications.noMessage',
  },
  [NotificationType.MissingManualReading]: {
    id: 'app.common.notifications.missingManualReading',
  },
});

export const NOTIFICATIONS = defineMessages({
  name: {
    id: 'app.common.notifications.field.name',
  },
  createdAt: {
    id: 'app.common.notifications.field.createdAt',
  },
  type: {
    id: 'app.common.notifications.field.type',
  },
  severity: {
    id: 'app.common.notifications.field.severity',
  },
  threshold: {
    id: 'app.common.notifications.field.threshold',
  },
  recipients: COMMON_TABLE_MESSAGES_TRANSLATED.recipients,
  thresholdHelp: {
    id: 'app.common.notifications.thresholdHelp',
  },
  nameHelp: {
    id: 'app.common.notifications.nameHelp',
  },
  establishmentHelp: {
    id: 'app.common.notifications.establishmentHelp',
  },
  supplyPointHelp: {
    id: 'app.common.notifications.supplyPointHelp',
  },
  meterHelp: {
    id: 'app.common.notifications.meterHelp',
  },
  periodHelp: {
    id: 'app.common.notifications.periodHelp',
  },
  commodityHelp: {
    id: 'app.common.notifications.commodityHelp',
  },
  owner: {
    id: 'app.common.notifications.owner',
  },
  ownerHelp: {
    id: 'app.common.notifications.ownerHelp',
  },
});

export const NOTIFICATION_SETTINGS_STATUS_TRANSLATED = defineMessages<NotificationSettingsStatus>({
  [NotificationSettingsStatus.Active]: COMMON_TABLE_MESSAGES_TRANSLATED.active,
  [NotificationSettingsStatus.Suspended]: { id: 'app.routes.notifications.notificationSettings.state.suspended' },
  [NotificationSettingsStatus.Archived]: { id: 'app.routes.notifications.notificationSettings.state.archived' },
});

export const NOTIFICATION_SETTINGS_MUTED = defineMessages({
  muted: { id: 'app.routes.notifications.notificationSettings.state.muted' },
  mutedForMe: { id: 'app.routes.notifications.notificationSettings.state.mutedForMe' },
});

export const NOTIFICATION_SEVERITY_TRANSLATED = defineMessages<NotificationSeverity>({
  [NotificationSeverity.Info]: {
    id: 'app.common.notifications.severity.info',
  },
  [NotificationSeverity.Warning]: {
    id: 'app.common.notifications.severity.warning',
  },
  [NotificationSeverity.Critical]: {
    id: 'app.common.notifications.severity.critical',
  },
});

export const NOTIFICATION_ACTIVITY_TRANSLATED = defineMessages<NotificationActivityKind>({
  [NotificationActivityKind.Seen]: {
    id: 'app.common.notifications.activity.seen',
  },
  [NotificationActivityKind.Resolved]: {
    id: 'app.common.notifications.activity.resolved',
  },
  [NotificationActivityKind.Archived]: {
    id: 'app.common.notifications.activity.archived',
  },
});
